// Register the service worker only in production or when explicitly enabled.
// Also exposes a "beforeinstallprompt" hook via window.__gfnDeferredInstall so
// the InstallPWABanner component can trigger a native install prompt.

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // Only enable in production builds (avoid caching issues during CRA dev)
  const isProd = process.env.NODE_ENV === "production";
  if (!isProd) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch(() => {});
  });
}

export function attachInstallPromptListener() {
  if (typeof window === "undefined") return;
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.__gfnDeferredInstall = e;
    window.dispatchEvent(new Event("gfn-install-available"));
  });
  window.addEventListener("appinstalled", () => {
    window.__gfnDeferredInstall = null;
    window.dispatchEvent(new Event("gfn-install-done"));
  });
}
